import React, { useRef, useEffect, useState, useContext } from 'react'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import styled from 'styled-components'
import gsap, { Power3 } from 'gsap'
import { Icon, LinkType } from '../shared'
import { UserNameContext } from '../../contexts'
import {
  mobileVw,
  desktopVw,
  desktopBreakpoint,
  colors,
  fonts,
  letterSpacing,
} from '../../styles'

import {
  useToggleCart,
  useToggleWishlist,
  useCart,
  useCustomer,
  useCountryRedirectAnalytics,
  useLocale,
} from '../../hooks'

const HeaderButtons = () => {

  const location = useLocation();

  const arr = [
    {
      title: 'United Kingdom',
      link: 'https://uk.maille.com/',
      svg:
        " %3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' enableBackground='new 0 0 512 512' version='1.1' viewBox='0 0 512 512' xmlSpace='preserve' %3E%3Cpath fill='%23F0F0F0' d='M0 85.333H512V426.66999999999996H0z' /%3E%3Cpath fill='%23D80027' d='M288 85.33L224 85.33 224 223.996 0 223.996 0 287.996 224 287.996 224 426.662 288 426.662 288 287.996 512 287.996 512 223.996 288 223.996z' /%3E%3Cg fill='%230052B4'%3E%3Cpath d='M393.785 315.358L512 381.034 512 315.358z' /%3E%3Cpath d='M311.652 315.358L512 426.662 512 395.188 368.307 315.358z' /%3E%3Cpath d='M458.634 426.662L311.652 344.998 311.652 426.662z' /%3E%3C/g%3E%3Cpath fill='%23F0F0F0' d='M311.652 315.358L512 426.662 512 395.188 368.307 315.358z' /%3E%3Cpath fill='%23D80027' d='M311.652 315.358L512 426.662 512 395.188 368.307 315.358z' /%3E%3Cg fill='%230052B4'%3E%3Cpath d='M90.341 315.356L0 365.546 0 315.356z' /%3E%3Cpath d='M200.348 329.51L200.348 426.661 25.491 426.661z' /%3E%3C/g%3E%3Cpath fill='%23D80027' d='M143.693 315.358L0 395.188 0 426.662 0 426.662 200.348 315.358z' /%3E%3Cg fill='%230052B4'%3E%3Cpath d='M118.215 196.634L0 130.958 0 196.634z' /%3E%3Cpath d='M200.348 196.634L0 85.33 0 116.804 143.693 196.634z' /%3E%3Cpath d='M53.366 85.33L200.348 166.994 200.348 85.33z' /%3E%3C/g%3E%3Cpath fill='%23F0F0F0' d='M200.348 196.634L0 85.33 0 116.804 143.693 196.634z' /%3E%3Cpath fill='%23D80027' d='M200.348 196.634L0 85.33 0 116.804 143.693 196.634z' /%3E%3Cg fill='%230052B4'%3E%3Cpath d='M421.659 196.636L512 146.446 512 196.636z' /%3E%3Cpath d='M311.652 182.482L311.652 85.331 486.509 85.331z' /%3E%3C/g%3E%3Cpath fill='%23D80027' d='M368.307 196.634L512 116.804 512 85.33 512 85.33 311.652 196.634z' /%3E%3C/svg%3E",
    },
    {
      title: 'United States',
      link: 'https://us.maille.com/',
      svg:
        " %3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 512 512' enableBackground='new 0 0 512 512'  version='1.1' xmlSpace='preserve' %3E%3Crect y='85.331' style='fill:%23F0F0F0;' width='512' height='341.337'/%3E%3Cg%3E%3Crect y='127.994' style='fill:%23D80027;' width='512' height='42.663'/%3E%3Crect y='213.331' style='fill:%23D80027;' width='512' height='42.663'/%3E%3Crect y='298.657' style='fill:%23D80027;' width='512' height='42.663'/%3E%3Crect y='383.994' style='fill:%23D80027;' width='512' height='42.663'/%3E%3C/g%3E%3Crect y='85.331' style='fill:%232E52B2;' width='256' height='183.797'/%3E%3Cg%3E%3Cpolygon style='fill:%23F0F0F0;' points='99.822,160.624 95.699,173.308 82.363,173.308 93.154,181.143 89.031,193.826 99.822,185.991 110.606,193.826 106.484,181.143 117.275,173.308 103.938,173.308 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='103.938,219.08 99.822,206.397 95.699,219.08 82.363,219.08 93.154,226.916 89.031,239.599 99.822,231.763 110.606,239.599 106.484,226.916 117.275,219.08 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='47.577,219.08 43.46,206.397 39.337,219.08 26.001,219.08 36.792,226.916 32.669,239.599 43.46,231.763 54.245,239.599 50.123,226.916 60.912,219.08 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='43.46,160.624 39.337,173.308 26.001,173.308 36.792,181.143 32.669,193.826 43.46,185.991 54.245,193.826 50.123,181.143 60.912,173.308 47.577,173.308 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='99.822,114.85 95.699,127.535 82.363,127.535 93.154,135.371 89.031,148.054 99.822,140.218 110.606,148.054 106.484,135.371 117.275,127.535 103.938,127.535 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='43.46,114.85 39.337,127.535 26.001,127.535 36.792,135.371 32.669,148.054 43.46,140.218 54.245,148.054 50.123,135.371 60.912,127.535 47.577,127.535 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='156.183,160.624 152.061,173.308 138.725,173.308 149.515,181.143 145.394,193.826 156.183,185.991 166.969,193.826 162.846,181.143 173.637,173.308 160.301,173.308 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='160.301,219.08 156.183,206.397 152.061,219.08 138.725,219.08 149.515,226.916 145.394,239.599 156.183,231.763 166.969,239.599 162.846,226.916 173.637,219.08 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='216.663,219.08 212.546,206.397 208.423,219.08 195.088,219.08 205.877,226.916 201.755,239.599 212.546,231.763 223.331,239.599 219.208,226.916 229.999,219.08 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='212.546,160.624 208.423,173.308 195.088,173.308 205.877,181.143 201.755,193.826 212.546,185.991 223.331,193.826 219.208,181.143 229.999,173.308 216.663,173.308 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='156.183,114.85 152.061,127.535 138.725,127.535 149.515,135.371 145.394,148.054 156.183,140.218 166.969,148.054 162.846,135.371 173.637,127.535 160.301,127.535 '/%3E%3Cpolygon style='fill:%23F0F0F0;' points='212.546,114.85 208.423,127.535 195.088,127.535 205.877,135.371 201.755,148.054 212.546,140.218 223.331,148.054 219.208,135.371 229.999,127.535 216.663,127.535 '/%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A",
    },
    {
      title: 'Canada',
      link: 'https://www.maille.com/ca/fr/',
      svg:
        "%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' enableBackground='new 0 0 512 512' version='1.1' viewBox='0 0 512 512' xmlSpace='preserve' %3E%3Cpath fill='%23F0F0F0' d='M0 85.331H512V426.65700000000004H0z' /%3E%3Cg fill='%23D80027'%3E%3Cpath d='M0 85.331H170.663V426.668H0z' /%3E%3Cpath d='M341.337 85.331H512V426.668H341.337z' /%3E%3Cpath d='M288 279.704L320 263.704 304 255.705 304 239.705 272 255.705 288 223.705 272 223.705 256 199.704 240 223.705 224 223.705 240 255.705 208 239.705 208 255.705 192 263.704 224 279.704 216.001 295.704 248.001 295.704 248.001 319.705 264.001 319.705 264.001 295.704 296.001 295.704z' /%3E%3C/g%3E%3C/svg%3E",
    },
    {
      title: 'Japan',
      link: 'http://www.maille.jp//',
      svg:
        "%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' enableBackground='new 0 0 512 512' version='1.1' viewBox='0 0 512 512' xmlSpace='preserve' %3E%3Cpath fill='%23F0F0F0' d='M0 85.331H512V426.668H0z' /%3E%3Ccircle cx='256' cy='255.994' r='96' fill='%23D80027' /%3E%3C/svg%3E",
    },
    {
      title: 'Spain',
      link: 'https://maille.com.es/',
      svg:
        "%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' enableBackground='new 0 0 512 512' version='1.1' viewBox='0 0 512 512' xmlSpace='preserve' %3E%3Cpath fill='%23FFDA44' d='M0 85.331H512V426.668H0z' /%3E%3Cg fill='%23D80027'%3E%3Cpath d='M0 85.331H512V199.106H0z' /%3E%3Cpath d='M0 312.882H512V426.65700000000004H0z' /%3E%3C/g%3E%3C/svg%3E",
    },
    {
        title: 'Germany',
        link: 'https://de.maille.com/',
        svg:
        "%3c%3fxml version='1.0' encoding='utf-8'%3f%3e %3c!-- Generator: Adobe Illustrator 27.7.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e %3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e.st0%7bfill:%23D80027%3b%7d .st1%7bfill:%23FFDA44%3b%7d%3c/style%3e%3cg%3e%3crect id='Rectangle_98' y='3' width='18' height='4'/%3e%3crect id='Rectangle_99' y='7' class='st0' width='18' height='4'/%3e%3crect id='Rectangle_100' y='11' class='st1' width='18' height='4'/%3e%3c/g%3e%3c/svg%3e",
    }
  ]
  const cart = useCart()
  const user = useCustomer()
  const quantities = []
  cart?.lineItems.map((item) => quantities.push(item.quantity))
  const toggleCart = useToggleCart()
  const toggleWishlist = useToggleWishlist()
  const refLang = useRef(null)
  const refListItem = useRef([])
  const [langOpen, setLangOpen] = useState(false)
  const [numberOfItems, setNumberOfItems] = useState(
    quantities.reduce((a, b) => a + b, 0),
  )

  const locale = useLocale();

  const [tl] = useState(gsap.timeline({ paused: true }))

  useEffect(() => {
    tl.set(refLang.current, { autoAlpha: 1 })
      .fromTo(
        refLang.current.childNodes[0],
        0.5,
        { yPercent: -100 },
        { yPercent: 0, ease: Power3.easeInOut },
      )
      .staggerFromTo(
        refListItem.current,
        0.8,
        { autoAlpha: 0, y: -10 },
        { autoAlpha: 1, y: 0, ease: Power3.easeOut },
        0.02,
        '-=.2',
      )
  }, [])

  
  useEffect(() => {
    if (cart) {
      setNumberOfItems(quantities.reduce((a, b) => a + b, 0))
    }
  }, [cart, user])

  const handleClick = () => {
    setLangOpen(true)
    if (!langOpen) tl.play()
  }

  const handleMouseLeave = () => {
    setLangOpen(false)
    if (langOpen) tl.reverse(0)
  }

  const enToFr = (url) => {
    const newurl = url.replace("ca/en", "ca/fr")
    return newurl
  }
  const frToEn = (url) => {
    const newurl = url.replace('ca/fr', 'ca/en')
    return newurl
  }
   let {firstName, lastName, setFirstName, setLastName} = useContext(UserNameContext)
  
  return (
    <>
      <ButtonWrapper>
        <div className='desktopOnly'>
          {
            locale === 'fr' &&
            <button
              type='button'
              onClick={() => {
                navigate(`/account`)
              }}
            >
              <StyledSpan style={{ color: `${colors.mailleGold}` }}>
                {user ? `${firstName} ${lastName}` : 'MON COMPTE'}
              </StyledSpan>
            </button>
          }
          {
            locale === 'en-CA' &&
            <button
              type='button'
              onClick={() => {
                navigate(`${enToFr(location.pathname)}`)
                // navigate(`/ca/fr`)
              }}
            >
              <StyledSpan style={{ color: `${colors.mailleGold}` }}>
                Version française
              </StyledSpan>
            </button>
          }
          {
            locale === 'fr-CA' &&
            <button
              type='button'
              onClick={() => {
                navigate(`${frToEn(location.pathname)}`)
                // navigate(`/ca/en`)
              }}
            >
              <StyledSpan style={{ color: `${colors.mailleGold}` }}>
                English Version
              </StyledSpan>
            </button>
          }
        </div>
        {/*Language Selector*/}
        <LangWrapper>
          <button onClick={() => handleClick()} type='button'>
            <StyledSpan>{locale}</StyledSpan>
          </button>
          <LangSelector ref={refLang}>
            <Animated onMouseLeave={() => handleMouseLeave()}>
              <ul>
                {arr.map(({ title, svg, link }, i) => {
                  return (
                    <li
                      key={i}
                      ref={(e) => {
                        refListItem.current[i] = e
                      }}
                      onClick={() => useCountryRedirectAnalytics(title)}
                    >
                      <a
                        href={link}
                        alt={`Ce lien va ouvrir une nouvelle fenêtre: ${title}`}
                      >
                        <img src={`data:image/svg+xml,${svg}`} alt={title + " Maille"} />
                        {title}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </Animated>
            <Overlay langOpen={langOpen} onClick={() => handleMouseLeave()} />
          </LangSelector>
        </LangWrapper>
        {locale === 'fr' &&
          <>
            <button type='button' onClick={() => toggleWishlist()}>
              <Icon name='heart' color='#fff' />
            </button>
            <button
              className='bag-wrapper'
              type='button'
              onClick={() => toggleCart()}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {numberOfItems > 0 && (
                <Items>
                  <div>{numberOfItems}</div>
                </Items>
              )}

              <Icon name='bag' color='#fff' />
            </button>          </>
        }

      </ButtonWrapper>
    </>
  )
}
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${mobileVw(25)};
  button {
    display: flex;
    width: auto;
    padding: 0;
    margin-left: ${mobileVw(10)};
    position: relative;

    cursor: pointer;
    &:first-of-type {
      display: block;
    }
    svg {
      height: auto;
      width: ${mobileVw(16)};
    }
  }
  .bag-wrapper {
    transform: translateY(${mobileVw(-3)});
    @media (min-width: ${desktopBreakpoint}) {
      transform: none;
    }
    svg {
      height: auto;
      width: ${mobileVw(14)};

      @media (min-width: ${desktopBreakpoint}) {
        width: ${desktopVw(14)};
      }
    }
  }
  @media (min-width: ${desktopBreakpoint}) {
    height: ${desktopVw(17)};
    align-items: flex-end;
    button {
      margin-left: ${desktopVw(14)};
      padding: 0;
      width: auto;
      &:first-of-type {
        display: flex;
      }
      &:nth-of-type(2),
      &:first-of-type {
        margin-left: ${desktopVw(14)};
      }
      svg {
        height: ${desktopVw(16)};
        max-width: ${desktopVw(19)};
      }
    }
  }
`

const StyledSpan = styled.span`
  color: ${colors.white};
  font-family: ${fonts.tivoli};
  font-size: ${mobileVw(18)};
  letter-spacing: ${mobileVw(1.6)};
  line-height: 1;
  text-transform: uppercase;
  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(18)};
    letter-spacing: ${desktopVw(1.4)};
  }
`

const Items = styled.span`
  color: ${colors.white};
  font-family: ${fonts.tivoli};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${mobileVw(13)};
  background: #c29938;
  border-radius: 50%;
  position: absolute;
  width: ${mobileVw(13)};
  height: ${mobileVw(13)};
  left: ${mobileVw(7)};
  top: ${mobileVw(9)};
  box-shadow: -1px -1px 14px 0px #f1e3e350;

  div {
    position: absolute;
    top: 56%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  @media (min-width: ${desktopBreakpoint}) {
    /* font-size: ${desktopVw(12)};
    top: ${desktopVw(5.5)}; */
    font-size: ${desktopVw(13)};
    width: ${desktopVw(13)};
    height: ${desktopVw(13)};
    left: ${desktopVw(7)};
    top: ${desktopVw(9)};
  }
`

const LangSelector = styled.div`
  position: absolute;
  color: ${colors.darkGrey};
  right: 0;
  top: ${desktopVw(37)};
  white-space: nowrap;
  font-family: ${fonts.tivoli};
  text-transform: uppercase;
  letter-spacing: ${letterSpacing(100)};
  overflow: hidden;
  visibility: hidden;
  li {
    padding: ${mobileVw(2)} 0;
    list-style: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: ${mobileVw(16)};
    img {
      height: ${mobileVw(13)};
      width: auto;
      margin: 0 ${mobileVw(20)} 0 0;
    }
    &:hover {
      color: ${colors.mailleGold};
    }
    @media (min-width: ${desktopBreakpoint}) {
      padding: ${desktopVw(2)} 0;
      font-size: ${desktopVw(16)};
      img {
        height: ${desktopVw(13)};
        width: auto;
        margin: 0 ${desktopVw(20)} 0 0;
      }
    }
  }
  ul {
    padding: 0;
    margin: 0;
  }
`

const LangWrapper = styled.div`
  display: none;
  position: relative;
  @media (min-width: ${desktopBreakpoint}) {
    display: inline-block;
  }
`

const Animated = styled.div`
  padding: ${desktopVw(10)} ${desktopVw(20)} ${desktopVw(10)} ${desktopVw(20)};
  background: white;
  position: relative;
  z-index: 1;
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  cursor: pointer;
  display: ${(props) => (props.langOpen ? 'block' : 'none')};
`

export default HeaderButtons
